// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"38a28d14","400":"763b87bd"}[chunkId] + ".chunk.js";
};